<template>
    <div class="invoiceResend">
        <van-form validate-first @submit="submitForm">
            <div class="invoiceResend-form-wrap flex-column">
                <van-field required v-model="form.email" label="电子邮件" placeholder="请输入电子邮件" :rules="[{ pattern: rules.email.regex, message: '请输入正确电子邮件' }]" />
                <van-field v-model="form.phone" label="短信" placeholder="请输入手机号码" :rules="[{ pattern: rules.phone.regex, message: '请输入正确手机号码' }]" />
                <div class="invoice-btn-wrap">
                    <van-button round block color="#009AF3 " class="comfirm-btn">提交</van-button>
                </div>
            </div>
        </van-form>
    </div>
</template>

<script>
import rules from "@/libs/fieldValidateRules";
import { resendInvoiceMsg } from "@/api/index";
export default {
    name: "InvoiceResend",
    data() {
        return {
            rules,
            form: {
                email: "",
                phone: "",
            },
        };
    },
    mounted() {
        this.form = {
            ...this.form,
            ...this.$route.params,
        };
    },

    methods: {
        submitForm() {
            resendInvoiceMsg(this.form).then((res) => {
                this.$toast("重发发票成功，请注意查收");
                this.$router.back(0);
            });
        },
    },
};
</script>

<style lang="less" scoped>
.invoiceResend {
    .invoiceResend-form-wrap {
        min-height: 100vh;
        .invoice-btn-wrap {
            padding: 24px;
            margin-top: auto;
        }
    }
}
</style>
